module.exports = __webpack_public_path__ + "img/icon_iPhone.dad83f01.png";